/* @flow */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React from 'react';
import Activity from 'entities/Activity';
import { loadActivityRecipients } from 'payments/reducers/activityRecipients';
import ChatAddParticipantContainer from 'chat/containers/ChatAddParticipantContainer.jsx';

type Props = {
  activity: Activity,
  loadActivityRecipients: (activityId: string) => mixed,
  children?: (disabled: boolean) => mixed,
 };

class ActivityAddParticipantContainer extends React.Component {
  props: Props;

  onAddParticipants = () => {
    this.props.loadActivityRecipients(this.props.activity.id);
  }

  render() {
    const chatUuid = this.props.activity.getChatUuid();

    if (!chatUuid) {
      return null;
    }

    return (
      <ChatAddParticipantContainer
        chatUuid={chatUuid}
        onAddParticipants={this.onAddParticipants}>
        {this.props.children}
      </ChatAddParticipantContainer>
    );
  }
}

function mapDispatchToProps(dispatch: Function) {
  // $FlowIssue
  return bindActionCreators({ loadActivityRecipients }, dispatch);
}

export default connect(undefined, mapDispatchToProps)(ActivityAddParticipantContainer);



// WEBPACK FOOTER //
// ./src/payments/containers/ActivityAddParticipantContainer.jsx